import React from "react";
import { Route, Routes } from "react-router-dom";

import TxRuralConference2025 from "./tx-rural-conference-2025/TxRuralConference2025";

const PagesRoute = () => {
  return (
    <Routes>
      <Route
        path="/tx-rural-conference-2025"
        element={<TxRuralConference2025 />}
      />
    </Routes>
  );
};

export default PagesRoute;
